export default __webpack_public_path__ + "static/media/README.b0728b82.md";